/**
 * Icon lookup tables.
 *
 * Separate from SidebarIcons.tsx so that module exports only components and
 * stays hot-reloadable — these maps are values, not components.
 */
import {
  BarChartIcon,
  CalendarIcon,
  ChartLineIcon,
  CheckSquareIcon,
  ClipboardIcon,
  CompareIcon,
  CompassIcon,
  DiceIcon,
  FolderIcon,
  HistoryIcon,
  HouseIcon,
  LandmarkIcon,
  LayoutIcon,
  ReceiptIcon,
  SlidersIcon,
  SunsetIcon,
  TableIcon,
  TrendUpIcon,
  UsersIcon,
  WalletIcon,
  WhatIfIcon,
  ZapIcon,
} from './SidebarIcons';

/** Icon lookup by sidebar item id */
export const SIDEBAR_ICONS: Record<string, () => JSX.Element> = {
  /* wizard steps */
  'step-1': ClipboardIcon,
  'step-2': UsersIcon,
  'step-3': WalletIcon,
  'step-4': HouseIcon,
  'step-5': TrendUpIcon,
  'step-6': ReceiptIcon,
  'step-7': SunsetIcon,
  'step-8': SlidersIcon,
  'step-9': CompassIcon,
  'step-10': CheckSquareIcon,
  /* projection views */
  'whatif': WhatIfIcon,
  'overview': LayoutIcon,
  'shock': ZapIcon,
  'montecarlo': DiceIcon,
  'sensitivity': BarChartIcon,
  'historical': HistoryIcon,
  'deferral': CalendarIcon,
  'iht': LandmarkIcon,
  'table': TableIcon,
  'compare': CompareIcon,
};

/** Section header icon lookup */
export const SECTION_ICONS: Record<string, () => JSX.Element> = {
  'plan': FolderIcon,
  'plan-details': FolderIcon,
  'projection': ChartLineIcon,
};
